import moment from "moment";
import { AuthStatusChangeComments } from "../../../../data-model/authStatusChangeComments";
import { pushAuthStatusChangeCommentsToLocalStorage } from "../../../../pages/singleOrderLayout/utils/helperForAuthStatusCommentsInLocalStorage";

/**
 * Creates an authorization status change comment object and stores it in local storage.
 *
 * This function constructs a comment with metadata including the comment text, reason,
 * J-code, comment type, user ID, and timestamp, then persists it to local storage
 * associated with the specified order ID.
 *
 * @param orderId - The unique identifier of the order to associate the comment with
 * @param commentText - The text content of the comment (will be trimmed)
 * @param reason - The reason for the authorization status change
 * @param jCode - The J-code associated with the authorization
 * @param commentType - The type of comment: "denial", "query", or "query_resolution"
 * @param userId - The ID of the user creating the comment
 *
 * @returns void
 *
 * @example
 * createDataForCommentsAndPushToLocalStorage(
 *   "order-123",
 *   "Prior authorization denied due to missing documentation",
 *   "Missing Documentation",
 *   "J1234",
 *   "denial",
 *   "user-456"
 * );
 */
export const createDataForCommentsAndPushToLocalStorage = (
  orderId: string,
  commentText: string,
  reason: string,
  jCode: string,
  commentType: "denial" | "query" | "query_resolution",
  userId: string,
) => {
  const comment: AuthStatusChangeComments = {
    comment: commentText.trim(),
    reason: reason ?? "",
    j_code: jCode ?? "",
    comment_type: commentType ?? "",
    commented_by: userId ?? "",
    created_at: moment().utc().format("YYYY-MM-DD HH:mm:ss.SSSSSS+00:00"),
  };

  pushAuthStatusChangeCommentsToLocalStorage(orderId, comment);
};
